// src/utils/blocklist.js
export const BLOCKED_TERMS = [
  'VISA_PREPAID_USD_OPEN', // block this SKU
];

const N = (s) => (s ?? "").toString().trim().toUpperCase();

// Safe nested getter
const val = (obj, path) =>
  path.split(".").reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);

// Normalize likely fields across different shapes
export const getSupplier = (p = {}) =>
  N(
    p.provider ??
      p.supplier ??
      p.source ??
      p.connector ??
      p.vendor ??
      p.providerName ??
      p.supplierName ??
      ""
  );

// Some APIs return brand as string OR object { name, code }
export const getBrand = (p = {}) =>
  N(
    p.brand?.name ??
      p.brand?.code ??
      p.brandName ??
      p.brand_code ??
      p.brandCode ??
      (typeof p.brand === "string" ? p.brand : "")
  );

export const getOfferLike = (p = {}) =>
  N(p.offerId ?? p.productSku ?? p.sku ?? p.skuId ?? p.id ?? "");

// helper to test a value against the blocklist (case-insensitive)
const matchesBlock = (value) => {
  const v = N(value);
  if (!v) return false;
  return BLOCKED_TERMS.some((t) => {
    const T = N(t);
    return v === T || v.includes(T);
  });
};

export const isBlocked = (p = {}) => {
  const supplier = getSupplier(p);
  const brand    = getBrand(p);
  const offer    = getOfferLike(p);
  const name     = N(p.name ?? p.brandName ?? "");

  // Fast checks (top-level)
  if (matchesBlock(supplier)) return true;
  if (matchesBlock(brand))    return true;
  if (matchesBlock(offer))    return true;
  if (matchesBlock(name))     return true;

  // Common nested paths
  const nestedValues = [
    "route.supplier",
    "route.provider",
    "meta.supplier",
    "metadata.supplier",
    "metadata.brand",
    "fullDetail.offerId",
    "fullDetail.productSku",
    "raw.offerId",
    "raw.productSku",
  ]
    .map((k) => N(val(p, k)))
    .filter(Boolean);

  return nestedValues.some(matchesBlock);
};
